const day = {
  113: require("../asset/day/113.svg").default,
  116: require("../asset/day/116.svg").default,
  119: require("../asset/day/119.svg").default,
  122: require("../asset/day/122.svg").default,
  143: require("../asset/day/143.svg").default,
  176: require("../asset/day/176.svg").default,
  179: require("../asset/day/179.svg").default,
  182: require("../asset/day/182.svg").default,
  185: require("../asset/day/185.svg").default,
  200: require("../asset/day/200.svg").default,
  227: require("../asset/day/227.svg").default,
  230: require("../asset/day/230.svg").default,
  248: require("../asset/day/248.svg").default,
  260: require("../asset/day/260.svg").default,
  263: require("../asset/day/263.svg").default,
  266: require("../asset/day/266.svg").default,
  281: require("../asset/day/281.svg").default,
  284: require("../asset/day/284.svg").default,
  293: require("../asset/day/293.svg").default,
  296: require("../asset/day/296.svg").default,
  299: require("../asset/day/299.svg").default,
  302: require("../asset/day/302.svg").default,
  305: require("../asset/day/305.svg").default,
  308: require("../asset/day/308.svg").default,
  311: require("../asset/day/311.svg").default,
  314: require("../asset/day/314.svg").default,
  317: require("../asset/day/317.svg").default,
  320: require("../asset/day/320.svg").default,
  323: require("../asset/day/323.svg").default,
  326: require("../asset/day/326.svg").default,
  329: require("../asset/day/329.svg").default,
  332: require("../asset/day/332.svg").default,
  335: require("../asset/day/335.svg").default,
  338: require("../asset/day/338.svg").default,
  350: require("../asset/day/350.svg").default,
  353: require("../asset/day/353.svg").default,
  356: require("../asset/day/356.svg").default,
  359: require("../asset/day/359.svg").default,
  362: require("../asset/day/362.svg").default,
  365: require("../asset/day/365.svg").default,
  368: require("../asset/day/368.svg").default,
  371: require("../asset/day/371.svg").default,
  374: require("../asset/day/374.svg").default,
  377: require("../asset/day/377.svg").default,
  386: require("../asset/day/386.svg").default,
  389: require("../asset/day/389.svg").default,
  392: require("../asset/day/392.svg").default,
  395: require("../asset/day/395.svg").default,
};

export default day;
